exports.connect = {
	url: "https://api.garennes-fliers.camp/"
}
